import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { PaymentService } from '../services/payment.service';
import { paymentStateActions } from './payment.actions';

@Injectable()
export class PaymentsEffects {

  constructor(
    private actions$: Actions,
    private paymentService: PaymentService,
  ) { }

  loadFlightsOffer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(paymentStateActions.loadFlightOfferData),
      exhaustMap((query: any) => { //TODO: complete types
        return this.paymentService.getFlightOffer(query.flightOfferId).pipe(
          map(res => {
            const { flightOffer } = res;
            return paymentStateActions.loadFlightOfferDataSuccess({ data: { flightOffer } });
        }),
        catchError((error: HttpErrorResponse) => {
          return of(paymentStateActions.loadFlightOfferDataFailure({ error: error?.message || String(error) } as any));
      }),
        )
      })
    )
  )

  orderFlight$ = createEffect(() =>
  this.actions$.pipe(
    ofType(paymentStateActions.orderFlight),
    exhaustMap((query: any) => { //TODO: complete types
      return this.paymentService.orderFlight(query.flightOffer, query.orderInformation).pipe(
        map(res => {
          const { flightOrder } = res;
          return paymentStateActions.orderFlightSuccess({ data: { flightOrder } });
      }),
      catchError((error: HttpErrorResponse) => {
        return of(paymentStateActions.orderFlightFailure({ error: error?.message || String(error) } as any));
    }),
      )
    })
  )
)
}
 